import React, { Component, useEffect, useState } from "react";

//custom
//import axios
import axios from "axios";

//utils
import {
  check_authorized,
  signoutuser_confirm,
  isloginuser,
  get_userseckey,
  getuniquedeviceid,
  signoutuser,
} from "../../utils/Helper/CheckAuth";
import CallURL from "../../utils/API/CallURL";
import {
  showLoading,
  stopLoading,
  sent_clean_var,
  scroll_to_top,
  ismobileno,
  fun_input_focus,
} from "../../utils/Helper/JSHelper";

//components
import Navigation from "../../components/Navigation/Navigation";
import CardTextNumber from "../../components/CardTextNumber/CardTextNumber";
import SearchKeyword from "../../components/SearchKeyword/SearchKeyword";

//componentsAdmin
import UserCard from "../../componentsAdmin/UserCard/UserCard";
import RegisterMobile from "../../componentsAdmin/RegisterMobile/RegisterMobile";

function ManageUser() {
  //temp variable
  const [list_temp_load, set_list_temp_load] = useState([]);

  //manage user variable
  const [user_count, set_user_count] = useState(0);
  const [searchword, set_searchword] = useState("");
  sessionStorage.setItem("manageuser_searchword", "");
  const [register_mobile, set_register_mobile] = useState("");

  //list
  const [item_list, set_item_list] = useState([]);

  //load on scroll in windows scroll event
  var scroll_limit = 20;
  var unique_key_count = 0;

  //starting on mount
  useEffect(() => {
    //change background color
    document.body.style = "background: white;";

    //isloginuser
    if (isloginuser()) {
      load_user_count();
      //set scroll event
      window.addEventListener("scroll", handle_scroll_load_list);
      //load_itemlist_first
      load_itemlist_first();
    }

    //if login check_authorized
    check_authorized("admin");
  }, [list_temp_load]);

  //like unmount method remove global event listner if component is unload
  useEffect(() => {
    return () => {
      //isloginuser
      if (isloginuser()) {
        // unsubscribe event
        window.removeEventListener("scroll", handle_scroll_load_list);
      }
    };
  }, []);

  //load_itemlist_first
  function load_itemlist_first() {
    //load first
    sessionStorage.setItem("manageuser_scroll_offset", 0);
    sessionStorage.setItem("manageuser_scroll_busy", "no");
    load_itemlist(
      scroll_limit,
      sessionStorage.getItem("manageuser_scroll_offset"),
      "first"
    );
  }

  //handle_scroll_load_list
  function handle_scroll_load_list() {
    //scroll activate when touch at bottom * 2
    var height_no_value = Number(window.innerHeight * 2);
    var scroll_no_value = Number(document.body.offsetHeight - height_no_value);
    if (window.innerHeight + window.scrollY >= scroll_no_value) {
      // you're at the bottom of the page
      fetchMoreData();
    }
  }

  //load_userlist
  function load_itemlist(lim, off, calltime) {
    //set scroll busy
    sessionStorage.setItem("manageuser_scroll_busy", "yes");
    if (calltime == "first") {
      set_item_list([]);
      unique_key_count = 0;
      sessionStorage.setItem("manageuser_scroll_offset", 0);
      lim = scroll_limit;
      off = sessionStorage.getItem("manageuser_scroll_offset");
      //showLoading
      showLoading();
    }
    //alert(lim + " off " + off + " " + calltime);
    // Create an object of formData
    const formData = new Object();

    //extra authorized user
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();

    //extra variable
    formData.limit = lim;
    formData.offset = off;
    formData.calltime = calltime;

    //extra variable
    formData.searchword = sent_clean_var(
      sessionStorage.getItem("manageuser_searchword")
    );

    // Send formData object
    axios
      .post(CallURL.load_user_list, formData)
      .then((response) => {
        if (calltime == "first") {
          stopLoading();
        }
        sessionStorage.setItem("manageuser_scroll_busy", "no");
        //console.log(response);
        //alert(response.data.apires)
        if (response.data.apires == "success") {
          //set user_list_for
          var itemlist_temp = [];
          for (var i = 0; i < response.data.rows.length; i++) {
            //add current offset value pair in user list
            response.data.rows[i]["mycurrentoffset"] = Number(
              parseInt(off) + i
            );
            var row = response.data.rows[i];
            //row.push({ username: "rushi " + i });
            //add into array
            itemlist_temp.push(row);
          }
          //alert("saved profile scroll");
          //alert(JSON.stringify(itemlist_temp));
          add_arr(itemlist_temp);
          //load second request sent
          if (calltime == "first") {
            fetchMoreData();
          }
        } else if (response.data.apires == "no_found") {
          document.getElementById("div_no_item_found").style.display = "none";
          document.getElementById("div_no_item_found").style.display = "block";
          sessionStorage.setItem("manageuser_scroll_busy", "yes");
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        if (calltime == "first") {
          stopLoading();
        }
        alert("Something went wrong. Try again.");
      });
  }
  const add_arr = (itemlist_temp) => {
    //alert("hi" + JSON.stringify(itemlist_temp));
    //appende to all previous
    set_item_list((prevState) => [...prevState, ...itemlist_temp]);
  };

  //no_user_found_return
  function no_item_found_return() {
    if (item_list.length == 0) {
      return (
        <div className="no_found_div">
          <br />
          <center>
            <font className="no_found_font">Information not found.</font>
          </center>
        </div>
      );
    }
  }

  //fetchMoreData
  function fetchMoreData() {
    if (sessionStorage.getItem("manageuser_scroll_busy") == "no") {
      //alert("Loading Started");
      var scroll_offset_temp =
        scroll_limit +
        parseInt(sessionStorage.getItem("manageuser_scroll_offset"));
      sessionStorage.setItem("manageuser_scroll_offset", scroll_offset_temp);
      load_itemlist(
        scroll_limit,
        sessionStorage.getItem("manageuser_scroll_offset"),
        "second"
      );
    }
  }

  function load_user_count() {
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    // Send formData object
    axios
      .post(CallURL.load_user_count, formData)
      .then((response) => {
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "unauthorized") {
          //make logout
          signoutuser();
        } else if (response.data.apires == "success") {
          //set data
          set_user_count(response.data.user_count);
        } else {
          //alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        //alert("Something went wrong. Try again.");
      });
  }

  //on search
  function onSearch(searchkeyword) {
    set_searchword(searchkeyword);
    sessionStorage.setItem("manageuser_searchword", searchkeyword);
    //load_itemlist_first
    load_itemlist_first();
  }

  //on register
  function onRegisterMobile(register_mobile) {
    set_register_mobile(register_mobile);
    if (!ismobileno(register_mobile)) {
      alert("Enter Valid Mobile No");
      fun_input_focus("register_mobile");
    } else {
      showLoading();
      // Create an object of formData
      const formData = new Object();
      // Update the formData object
      formData.secuserkey = get_userseckey();
      formData.deviceid = getuniquedeviceid();
      formData.register_mobile = register_mobile;
      // Send formData object
      axios
        .post(CallURL.register_user, formData)
        .then((response) => {
          stopLoading();
          //console.log(response);
          //alert(response.data.apires);
          if (response.data.apires == "success") {
            alert(register_mobile + " registred.");
            //load_user_count
            load_user_count();
            //load_itemlist_first
            load_itemlist_first();
          } else if (response.data.apires == "found") {
            alert(register_mobile + " already registred.");
          } else {
            alert("Something went wrong. Try again.");
          }
        })
        .catch((error) => {
          stopLoading();
          console.log(error);
          alert("Something went wrong. Try again.");
        });
    }
  }

  function showManageUser() {
    return (
      <div className="container">
        <div className="row">
          <div className="col s12 m2 l3"></div>
          <div
            className="col s12 m8 l6 app_view_contain_remove"
            style={{ wordBreak: "break-word" }}
          >
            <center>
              <font className="font_sub_title">Manage User</font>
            </center>
            <hr />
            <br />
            <RegisterMobile
              onRegisterMobile={onRegisterMobile}
              registerMobile={register_mobile}
            />
            <CardTextNumber
              text_title="#Registered User"
              text_number={user_count}
            />
            <br />
            <SearchKeyword
              placeholder="Mobile or Name"
              onSearch={onSearch}
              searchWord={searchword}
            />
            <hr />
            <br />
            <div style={{ wordBreak: "break-word", width: "100%" }}>
              {item_list.map((item) => {
                unique_key_count++;
                const index = Number(unique_key_count - 1);
                const user_unique_key = unique_key_count + "_item_list";
                return (
                  <div
                    key={user_unique_key}
                    id={user_unique_key}
                    className="div_item z-depth-0"
                  >
                    <UserCard item_info={item} />
                  </div>
                );
              })}
              <div id="div_no_item_found" style={{ display: "none" }}>
                {no_item_found_return()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <React.Fragment>
      <div
        className="fixed-action-btn"
        style={{
          marginBottom: "-15px",
          bottom: "70px",
          right: "10px",
          left: "auto",
        }}
      >
        <a
          className="btn-floating z-depth-1 blue"
          onClick={() => scroll_to_top("smooth")}
        >
          <i className="fa fa-arrow-up"></i>
        </a>
      </div>
      {showManageUser()}
      <Navigation link_type="other" />
    </React.Fragment>
  );
}

export default ManageUser;
